<div class="container-fluid">
  <div class="row mb-2">
    <h3>CISA - Operações</h3>
  </div>

  <!--
      <div class="row mb-2">
        <div class="col-lg-3 col-sm-6">
            <a (click)="openDialog('Bradesco')" class="card">
                <div class="content">
                    <div class="row mb-2">
                        <div class="wrapper-simbolo">
                            <div class="icon-big icon-success text-center">
                                <i class="fa fa-dollar-sign"></i>
                            </div>
                        </div>
                        <div class="wrapper-numbers">
                            <div class="numbers">
                                <p>Bradesco</p>
                                1.345
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <hr />
                        <div class="stats">
                            <i class="fa fa-sync"></i> Atualizado há 2 hora(s)
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-lg-3 col-sm-6">
            <a (click)="openDialog('Itaú')" class="card">
                <div class="content">
                    <div class="row mb-2">
                        <div class="wrapper-simbolo">
                            <div class="icon-big icon-danger text-center">
                                <i class="fa fa-dollar-sign"></i>
                            </div>
                        </div>
                        <div class="wrapper-numbers">
                            <div class="numbers">
                                <p>Itaú</p>
                                1.345
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <hr />
                        <div class="stats">
                            <i class="fa fa-sync"></i> Atualizado há 1 hora(s)
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-lg-3 col-sm-6">
            <a (click)="openDialog('Socopa')" class="card">
                <div class="content">
                    <div class="row mb-2">
                        <div class="wrapper-simbolo">
                            <div class="icon-big icon-info text-center">
                                <i class="fa fa-dollar-sign"></i>
                            </div>
                        </div>
                        <div class="wrapper-numbers">
                            <div class="numbers">
                                <p>Socopa</p>
                                1.345
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <hr />
                        <div class="stats">
                            <i class="fa fa-sync"></i> Atualizado há 2 hora(s)
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div> -->

  <div class="progress" *ngIf="isTimezoneLoaded()">
    <div
      class="progress-bar bg-step-1"
      *ngIf="janelaMenorHorario(8)"
      role="progressbar"
      aria-valuenow="20"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      08h
    </div>
    <div
      class="progress-bar bg-step-2"
      *ngIf="janelaMenorHorario(10)"
      role="progressbar"
      aria-valuenow="20"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      10h
    </div>
    <div
      class="progress-bar bg-step-3"
      *ngIf="janelaMenorHorario(12)"
      role="progressbar"
      aria-valuenow="20"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      12h
    </div>
    <div
      class="progress-bar bg-step-4"
      *ngIf="janelaMenorHorario(14)"
      role="progressbar"
      aria-valuenow="20"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      14h
    </div>
    <div
      class="progress-bar bg-step-5"
      *ngIf="janelaMenorHorario(16)"
      role="progressbar"
      aria-valuenow="20"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      16h
    </div>
    <div
      class="progress-bar bg-step-6"
      *ngIf="janelaMenorHorario(19)"
      role="progressbar"
      aria-valuenow="20"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      19h
    </div>
  </div>

  <form #thisForm="ngForm" class="filter">
    <mat-card>
      <mat-card-header> </mat-card-header>
      <mat-card-content class="container-fluid">
        <div class="row mb-2">
          <div class="col-3" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoDe"
                [(ngModel)]="StartDate"
                [matDatepicker]="picker"
                placeholder="Período de"
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-3" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoAte"
                [(ngModel)]="EndDate"
                [matDatepicker]="picker2"
                placeholder="Até"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6">
            <ng-select
              bindLabel="description"
              bindValue="id"
              name="statusId"
              notFoundText="Nenhum status encontrado"
              placeholder="Status"
              [(ngModel)]="CodeStatus"
            >
              <ng-option *ngFor="let status of statuses" [value]="status.id">{{
                status.description
              }}</ng-option>
            </ng-select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3">
            <mat-form-field>
              <mat-label>Arquivo</mat-label>
              <input
                matInput
                name="arquivo"
                [(ngModel)]="FileName"
                placeholder="Arquivo"
              />
            </mat-form-field>
          </div>
          <div class="col-3">
            <ng-select
              bindLabel="name"
              bindValue="id"
              name="fundId"
              notFoundText="Nenhum fundo encontrado"
              placeholder="Fundo"
              [(ngModel)]="FundDocument"
            >
              <ng-option *ngFor="let item of funds" [value]="item.document">{{
                item.name
              }}</ng-option>
            </ng-select>
          </div>
          <div class="col-3">
            <ng-select
              bindLabel="name"
              bindValue="code"
              name="bankId"
              notFoundText="Nenhum banco encontrado"
              placeholder="Banco"
              [(ngModel)]="BankCode"
              class="fundo"
            >
              <ng-option *ngFor="let bank of Banks" [value]="bank.code">{{
                bank.name
              }}</ng-option>
            </ng-select>
          </div>
          <div class="offset-md-1"></div>
          <div class="col-1">
            <button mat-raised-button type="button" (click)="clear()">
              Limpar
            </button>
          </div>
          <div class="col-1">
            <button mat-raised-button type="submit" (click)="populate()">
              Buscar
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>

  <!-- <div class="row mb-2" *ngIf="fundoExiste()">
    <div class="col-lg-3 col-sm-6">
      <a (click)="openDialog('Santander')" class="card">
        <div class="content">
          <h5>Santander</h5>
          <div class="row mb-2">
            <div class="wrapper-numbers">
              <div class="numbers">
                <p>Cobrança: R$ 1.000.000.000,55</p>
                <p>Movimento: R$ 1.000.000.000,55</p>
              </div>
            </div>
          </div>
          <div class="footer">
            <hr />
            <div class="stats">
              <i class="fa fa-sync"></i> Atualizado há 1 hora(s)
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col-lg-3 col-sm-6">
      <a (click)="openDialog('Paulista')" class="card">
        <div class="content">
          <h5>Paulista</h5>
          <div class="row mb-2">
            <div class="wrapper-numbers">
              <div class="numbers">
                <p>Cobrança: R$ 1.000.000.000,55</p>
                <p>Movimento: R$ 1.000.000.000,55</p>
              </div>
            </div>
          </div>
          <div class="footer">
            <hr />
            <div class="stats">
              <i class="fa fa-sync"></i> Atualizado há 1 hora(s)
            </div>
          </div>
        </div>
      </a>
    </div>
  </div> -->

  <div class="row mb-2">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table">
      <ng-container matColumnDef="fundName">
        <th mat-header-cell *matHeaderCellDef>Nome do fundo</th>
        <td mat-cell *matCellDef="let element">{{ element.fund }}</td>
      </ng-container>

      <ng-container matColumnDef="paymentDate">
        <th mat-header-cell *matHeaderCellDef>Data do Pagamento</th>
        <td mat-cell *matCellDef="let element" class="data">
          {{ element.paymentDate | date: "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="processingDate">
        <th mat-header-cell *matHeaderCellDef>Data do Processamento</th>
        <td mat-cell *matCellDef="let element" class="data">
          {{ element.processingDate | date: "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tedValue">
        <th mat-header-cell *matHeaderCellDef>Valor TED</th>
        <td mat-cell *matCellDef="let element">
          {{ element.amountTED | currency: "R$":"symbol":"1.2-2" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="toBankAccount">
        <th mat-header-cell *matHeaderCellDef>Conta Destino</th>
        <td mat-cell *matCellDef="let element">{{ element.toBankAccount }}</td>
      </ng-container>

      <ng-container matColumnDef="sequenceNumber">
        <th mat-header-cell *matHeaderCellDef>Sequencial</th>
        <td mat-cell *matCellDef="let element">{{ element.sequenceNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let detail" colspan="7" style="padding: 0">
          <div
            class="row mb-2 detail"
            *ngFor="let detailElement of detail.history"
          >
            <div class="column">
              <strong>Data:</strong>
              {{ detailElement.date | date: "dd/MM/yyyy HH:mm:ss" }}
            </div>
            <div class="column">
              <strong>Status:</strong> {{ detailElement.status }}
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        matRipple
        [class.expanded]="expandedElement == row.id"
        (click)="expandedElement = row.id"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
      <tr
        mat-row
        matRipple
        [class.expanded]="expandedElement == row.id"
        *matRowDef="
          let row;
          columns: ['expandedDetail'];
          when: isExpansionDetailRow
        "
        [@detailExpand]="row.id == expandedElement ? 'expanded' : 'collapsed'"
      ></tr>
    </table>
  </div>

  <br />

  <paginador
    [listedPages]="listedPages"
    [firstItemOnPage]="firstItemOnPage"
    [lastItemOnPage]="lastItemOnPage"
    [totalPages]="totalPages"
    [totalItems]="totalItems"
    [currentPage]="currentPage"
    [itemsPerPage]="[10, 25, 50, 100, 200]"
    (onSearch)="populate($event[0], $event[1])"
  ></paginador>
</div>
